import {Stack, Typography} from '@mui/material';
import {Drawer} from 'presentation/components/Drawer';
import {Loading} from 'presentation/components/Loading/Loading';

import {translations} from 'presentation/translations-new';
import React from 'react';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {useOpenExamDrawerStore} from '../../store/useOpenExamDrawerStore';
import {ExamItemListDrawer} from '../ExamItemListDrawer';
import {CustomSnackbar} from '../CustomSnackbar';
import {useMedicalReportItem} from 'presentation/modules/examResults/hooks/useMedicalReportItem';

const {subtitle, downloadPartialResults, downloadCompleteResult, downloadError, downloadInfo} =
	translations['pt-br'].privateFlow.myHospitalization.exams.drawer;

export const ExamDrawer = React.memo(() => {
	const {isMobile} = useMediaQueries();
	const examData = useOpenExamDrawerStore(state => state.dataExam);
	const closeDrawer = useOpenExamDrawerStore(state => state.resetDataExam);
	const isCompleteResult = useOpenExamDrawerStore(state => state.isCompleteResult);
	const getExamByDownload = useOpenExamDrawerStore(state => state.getExamByDownload);
	const examByDownload = getExamByDownload();
	const examDataLength = examData?.list.length ?? 0;
	const showPlural = examDataLength === 1 ? '' : 's';

	const {openPdf, operationState} = useMedicalReportItem({
		medicalReport: examByDownload,
	});

	const isInfoAlert =
		operationState.error &&
		(operationState.errorType === 'notFound' || operationState.errorType === 'noContent');

	const isErrorAlert = operationState.error && operationState.errorType === 'generic';

	return (
		<Drawer.Root
			onClose={closeDrawer}
			onOpen={() => null}
			open={!!examData}
			data-test-id="exam-drawer">
			<CustomSnackbar
				title={downloadInfo.title}
				description={downloadInfo.description}
				snackProps={{open: isInfoAlert}}
				alertProps={{severity: 'info'}}
			/>
			<CustomSnackbar
				title={downloadError.title}
				description={downloadError.description}
				snackProps={{open: isErrorAlert}}
				alertProps={{severity: 'error'}}
			/>
			<Drawer.Header
				title={examData?.title}
				onClose={closeDrawer}
				containerPadding={isMobile ? '0 8px 16px 16px' : '0 16px 16px 24px'}
			/>
			<Drawer.Content>
				<Stack padding={'16px'}>
					<Typography variant="subtitle2" color={'primary'}>
						{subtitle}
						{showPlural}
					</Typography>
					<Stack gap={'16px'}>
						{examData?.list.map((exam, index) => (
							<ExamItemListDrawer key={index} exam={exam} isFirst={index === 0} />
						))}
					</Stack>
				</Stack>
			</Drawer.Content>
			<Drawer.Footer
				hideFirstButton
				secondButtonTitle={
					<Stack pl={'8px'} direction={'row'} gap={'8px'}>
						{operationState.loading ? <Loading size={24} color="inherit" /> : null}
						{isCompleteResult() ? downloadCompleteResult : downloadPartialResults}
					</Stack>
				}
				secondButtonOnClick={openPdf}
				secondButtonDisabled={operationState.loading}
			/>
		</Drawer.Root>
	);
});
